import React from 'react';
import { Grid, Typography, TextField, Button } from '@material-ui/core';
import Logo from "../../../images/logo.png";
import { Link } from 'react-router-dom';
import Email from 'validator/lib/isEmail';
import { withSnackbar } from 'notistack'

import './footer.css';

import { MaskTelefone } from '../../../utils/mask';

//icons
import FacebookIcon from '../../../images/svg/facebook.svg';
import TwitterIcon from '../../../images/svg/twitter.svg';
import InstagramIcon from '../../../images/svg/instagram.svg';
import LocalIcon from '../../../images/svg/placeholder.svg';
import TelefoneIcon from '../../../images/svg/phone.svg';
import EmailIcon from '../../../images/svg/email.svg';

// services
import ContatoAPI from '../../../services/api/Contato';

//utils
import { formatTel, formatCEP } from '../../../utils/format';

const menus = [
	{
		nome: 'Inicio',
		url: '/inicio',
	},
	{
		nome: 'O Shopping',
		url: '/o-shopping',
	},
	{
		nome: 'Lojas',
		url: '/lojas',
	},
	{
		nome: 'Cinema',
		url: '/cinema',
	},
	{
		nome: 'Serviços',
		url: '/servicos',
	},
	{
		nome: 'Eventos',
		url: '/eventos',
	},
	{
		nome: 'Fale Conosco',
		url: '/fale-conosco',
	}
]

class FooterApp extends React.Component {
	state = {
		nome: '',
		email_laster: '',
		whatsapp: '',

		loading:false,

		isNome:false,
		isEmail:false,
		isWhatsapp:false,
	}

	Submit = (event) => {
		const { enqueueSnackbar } = this.props;
		const { nome, email_laster, whatsapp } = this.state;
		event.preventDefault();
		this.setState({ isNome: false, isEmail: false, isWhatsapp: false });
		if (nome === '') {
			this.setState({ isNome: true }, () => enqueueSnackbar('Preencha o campo de nome'));
			return;
		}
		if (!Email(email_laster)) {
			this.setState({ isEmail: true }, () => enqueueSnackbar('Digite um email válido!'));
			return;
		}
		if (whatsapp === '') {
			this.setState({ isWhatsapp: true }, () => enqueueSnackbar('Preencha o campo de telefone'));
			return;
		}
		this.setState({ loading:true }, () => enqueueSnackbar("Aguarde efetuando o cadastro.."));
		let forms = {
			nome: nome,
			email: email_laster,
			telefone: whatsapp,
		}
		ContatoAPI.cadastro(forms)
					.then(res => {
						res.json().then(res => {
							if (res.msg) {
								this.setState({ loading: false }, () => enqueueSnackbar(res.msg));
								return;
							}
							this.setState({ loading:false,
											nome: '',
											email_laster: '',
											whatsapp: '', }, () => enqueueSnackbar('Cadastro efetuado com sucesso'))
						})
					}).catch(() => this.setState({ loading: false }, () => enqueueSnackbar('Não foi possivel efetuar o cadastro, tente novamente mais tarde.')))

		return;
	}

    render() {
		const { nome, email_laster, whatsapp, isNome, isEmail, isWhatsapp, loading } = this.state;
		const { func_seg_sab_loja, func_seg_sab_lazer, func_domingo_loja, func_domingo_lazer,
				logradouro, bairro, cidade_uf, cep, telefone, email } = this.props.informacoes;
        return (
				<footer className="footer_webapp__container" >
					<div className="footer_webapp__newsletter" >
						<div className="newsletter__container" >
							<Grid container spacing={16} >
								<Grid item md={4} xs={12} >
									<Typography variant="h6">
										Redes Sociais
									</Typography>
									<Typography variant="subtitle1" gutterBottom>
										Siga e fique por dentro de todas as novidades
									</Typography>
									<Grid container spacing={16} >
										<Grid item md={12} xs={12} >
											<a href="https://www.facebook.com/ShoppingNorteSul" target="_BLANK" >
												<img className="iconSocial" src={FacebookIcon} alt="" />
											</a>
											<a href="https://twitter.com/shop_nortesul" target="_BLANK" >
												<img className="iconSocial" src={TwitterIcon} alt="" />
											</a>
											<a href="https://www.instagram.com/shoppingnortesul/" target="_BLANK" >
												<img className="iconSocial" src={InstagramIcon} alt="" />
											</a>
										</Grid>
									</Grid>
								</Grid>
								<Grid item md={8} xs={12} >
									<Typography variant="h6">
										NewsLetter
									</Typography>
									<Typography variant="subtitle1" gutterBottom>
										Receba nossas novidades
									</Typography>
									<form onSubmit={this.Submit} >
										<Grid container spacing={16} >
											<Grid item md={3} xs={12} >
												<TextField
													id="outlined-name"
													label="Nome"
													value={nome}
													error={isNome}
													fullWidth
													onChange={(f) => this.setState({ nome: f.target.value })}
													margin="normal"
													variant="outlined"
												/>
											</Grid>
											<Grid item md={3} xs={12} >
												<TextField
													id="outlined-name"
													label="Email"
													value={email_laster}
													error={isEmail}
													fullWidth
													onChange={(f) => this.setState({ email_laster: f.target.value })}
													margin="normal"
													variant="outlined"
												/>
											</Grid>
											<Grid item md={3} xs={12} >
												<TextField
													id="outlined-name"
													label="WhatsApp"
													value={whatsapp}
													InputProps={{
														inputComponent: MaskTelefone,
													}}
													error={isWhatsapp}
													fullWidth
													onChange={(f) => this.setState({ whatsapp: f.target.value })}
													margin="normal"
													variant="outlined"
												/>
											</Grid>
											<Grid item md={3} xs={12} >
												<Button variant="contained" size="large" type="submit" color="default" disabled={loading} > Cadastrar </Button>
											</Grid>
										</Grid>
									</form>
								</Grid>
							</Grid>
						</div>
					</div>
					<div className="footer_webapp__information" >
						<Grid container spacing={16} >
							<Grid item md={4} xs={12} >
								<Grid container >
									<Grid item md={12} xs={12} >
										<img className="logo" src={Logo} alt="Logo" />
									</Grid>
									<Grid item md={12} xs={12} >
										<div className="information__row" >
											<img className="information__row_icon" src={LocalIcon} alt="Local" />
											<div className="information__row_text" >
												<p>{logradouro}</p>
												<p>{bairro} - CEP {formatCEP(String(cep))}</p>
												<p>{cidade_uf}</p>
											</div>
										</div>
									</Grid>
									<Grid item md={12} xs={12} >
										<div className="information__row" >
											<img className="information__row_icon" src={TelefoneIcon} alt="SAC" />
											<div className="information__row_text" >
												<p>SAC</p>
												<p>{formatTel(String(telefone))}</p>
											</div>
										</div>
									</Grid>
									<Grid item md={12} xs={12} >
										<div className="information__row" >
											<img className="information__row_icon" src={EmailIcon} alt="SAC" />
											<div className="information__row_text" >
												<p>Email</p>
												<p>{email}</p>
											</div>
										</div>
									</Grid>
								</Grid>
							</Grid>
							<Grid item md={4} xs={12} >
								<Grid item md={12} xs={12} >
									<Typography variant="h6" className="title_column" >
										SHOPPING NORTE SUL
									</Typography>
								</Grid>
								<Grid item md={12} xs={12} >
									<ul className="menulist" >
										{menus.map((m,k) => <li key={k} ><Link to={m.url} >{m.nome}</Link></li>)}
									</ul>
								</Grid>
							</Grid>
							<Grid item md={4} xs={12} >
								<Grid item md={12} xs={12} >
									<Typography variant="h6" className="title_column" >
										HORÁRIO DE FUNCIONAMENTO
									</Typography>
								</Grid>
								<Grid item md={12} xs={12} >
									<div className="information__row" >
										<div className="information__row_text funcionamento" >
											<p className="title" >Segunda a Sábado:</p>
											<p>Lojas: {func_seg_sab_loja}</p>
											<p>Alimentação: {func_seg_sab_lazer}</p>
										</div>
									</div>
								</Grid>
								<Grid item md={12} xs={12} >
									<div className="information__row" >
										<div className="information__row_text funcionamento" >
											<p className="title" >Domingo e Feriados:</p>
											<p>Lojas: {func_domingo_loja}</p>
											<p>Alimentação: {func_domingo_lazer}</p>
										</div>
									</div>
								</Grid>
							</Grid>
						</Grid>
					</div>
					<div className="footer_webapp__copyright" >
						<div className="copyright__container" >
							<p>Shopping Norte Sul. &copy; Todos os direitos reservados.</p>
						</div>
					</div>
				</footer>
        );
    }
}

export default withSnackbar(FooterApp);



// WEBPACK FOOTER //
// ./src/web/components/FooterApp/index.js